import { useState } from 'react';
import assetService from '../../Services/assetService';
import { Button, Form, InputGroup, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import "./SearchBar.css"
import { setFulltext } from '../../Reducers/filterReducer';

export default function SearchBar({ searchByText, setIsLoading }) {
    const [searchTerm, setSearchTerm] = useState("");

    const { t } = useTranslation();

    const filters = useSelector((state) => state.filter.filters);
    const channelGuid = useSelector((state) => state.channel.channelGuid);

    const dispatch = useDispatch();

    const handleSearch = async () => {
        dispatch(setFulltext(searchTerm));
    };

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            handleSearch();
        }
    };

    return (
        <Container fluid className='panel panel-body'>
            <InputGroup className='searchbar-home'>
                <Form.Control
                    className="h-100"
                    placeholder={t('search')}
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyPress={handleKeyPress}
                />
                <Button variant="primary" id="button-addon2" onClick={handleSearch}>
                    <i className="bi bi-search" />
                </Button>
            </InputGroup>
        </Container>
    );
}